acelerador.component('acelerador.aceleradorDetalheComponent', {
    templateUrl: 'acelerador/aceleradorDetalhe/aceleradorDetalhe.html',
    controller: 'acelerador.aceleradorDetalheController',
    controllerAs: '$ctrl'
});

acelerador.controller('acelerador.aceleradorDetalheController', ['$scope', '$state', 'coreFb', 'coreLanguage', '$sce', function($scope, $state, $fb, $text, $sce){
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {
        idProduto: null,
        idModulo:null
    };

    const _getArtigo=(idFaq, idArtigo)=>{

        $fb.db.get(`cad_faq/${idFaq}/artigos/${idArtigo}`).then(doc=>{
            $ctrl.artigo = doc;
            $state.params.showGlobalLoading = false;
        });

    };

    $ctrl.trust=(value)=>{
        return $sce.trustAsHtml(value);
    };

    $ctrl.$onInit = () => {
        
        let idFaq = $state.params.idFaq;
        let idArtigo = $state.params.idArtigo;

        _getArtigo(idFaq, idArtigo);
    }

}]);